import React from "react";
import { TExperienceData } from "./Experience";

const ExperienceHeader = ({
  jobTitle,
  company,
  companyLocation,
  jobType,
  workModel,
}: Partial<Omit<TExperienceData, "description" | "techs">>) => {
  return (
    <>
      <h3 className="vertical-timeline-element-title text-lg font-bold">
        {jobTitle}
      </h3>
      <h4 className="vertical-timeline-element-subtitle text-xs md:text-sm lg:text-lg">
        <span>{company}</span> | <span>{companyLocation}</span>
      </h4>
      <h5 className="text-xs md:text-sm lg:text-lg">
        <span>{jobType}</span> | <span>{workModel}</span>
      </h5>
    </>
  );
};

export default ExperienceHeader;
